import isArray from 'lodash-es/isArray'
import cloneDeep from 'lodash-es/cloneDeep'

export default {
  props: [],
  methods: {
    abstractDispatch (action, value) {
      this.$store.dispatch(this.namespace + action, value)
    },
    abstractPromiseDispatch (action, value) {
      return this.$store.dispatch(this.namespace + action, value)
    },
    abstractCommit (mutation, value) {
      this.$store.commit(this.namespace + mutation, value)
    },
    abstractStateMapper (propName) {
      const store = this.$store.state[this.namespace]
      if (!isArray(propName)) {
        return store[`${propName}`]
      }

      return this.mapStoreLevels(store, propName)
    },
    deepStore () {
      const levels = this.namespace.split('/')
      if (levels.length === 1) {
        return this.$store.state[this.namespace]
      } else {
        const store = this.$store.state
        return this.mapStoreLevels(store, levels)
      }
    },
    abstractGetter (getterName) {
      return this.$store.getters[this.namespace + getterName]
    },
    mapStoreLevels (store, props) {
      const item = props[0]
      if (props.length === 1) {
        return store[`${item}`]
      }

      const index = props.indexOf(item)
      const newProps = cloneDeep(props)
      if (index > -1) {
        newProps.splice(index, 1)
      }

      if (isArray(props) && newProps.length > 0) {
        return this.mapStoreLevels(store[`${item}`], newProps)
      }
    }
  }
}

